enum InterestPaymentStrategyEnum {
    Reinvest = 'REINVEST',
    Withdraw = 'WITHDRAW',
}

export default InterestPaymentStrategyEnum;
